import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { SalonService } from '../../services/salon.service';
import { Communication } from '../../models/communication/communication.model';
import { List } from 'immutable';
import { MarketingHistoryPage } from './marketing-history/marketing-history.page';

@Component({
  selector: 'smr-marketing-history-list',
  templateUrl: './marketing-history-list.component.html',
  styleUrls: ['./marketing-history-list.component.scss'],
})
export class MarketingHistoryListComponent implements OnInit {

  public isLoading: boolean;

  public anErrorOccuredWhileLoadingCommunicationHistory: boolean;

  public history: List<Communication>;
  
  constructor (private modalController: ModalController,
      private salonService: SalonService) {
    this.isLoading = true;
    this.history = List([]);
  }

  public ngOnInit () {
    this.loadHistory();
  }

  public onTapToReload () {
    this.isLoading = true;
    this.anErrorOccuredWhileLoadingCommunicationHistory =  false;
    this.loadHistory();
  }

  public loadHistory () {
    this.history = List([]);
    this.isLoading = true;
    this.salonService.bulkCommunicationHistory()
      .subscribe({
        next:(history: List<Communication>) => {
        this.history = history;
        this.isLoading = false;
        this.anErrorOccuredWhileLoadingCommunicationHistory = false;
      },
      error: (e) => {
        this.isLoading = false;
        this.anErrorOccuredWhileLoadingCommunicationHistory = true;
      }
    });
  }

  public async viewCommunication (communication: Communication) {
    const modal = await this.modalController.create({
      component: MarketingHistoryPage, 
      componentProps:{ communication: communication
      }
    });
    return await modal.present();
  }


}
